import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { convertPercentage } from "../../../../util/targetCalc";

const TargetDegradeSection = (props) => {
	const convPer = convertPercentage;

	const register = props.register;
	const isEditMode = props.isEditMode;
	const setValue = props.setValue;
	const watch = props.watch;
	const data = props.data;
	const [errors, setErrors] = useState({});

	const degradation = watch("degradation", convPer(data.degradation));

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) => {
		const value = evt.target.value;
		setValue(inputName, value);
	};

	useEffect(() => {
		setErrors(props.errors);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>Yearly Degradation (%)</h5>
			<hr />
			<Row>
				<Col md="12">
					<Col md="2">
						<label htmlFor="degradation">Degradation Percentage</label>
						{errors.degradation && errors.degradation.type == "required" && (
							<span className="required">*required</span>
						)}
					</Col>
					<Col md="2">
						<input
							type="number"
							step="0.01"
							ref={register}
							name="degradation"
							defaultValue={degradation}
							readOnly={!isEditMode}
							onChange={(evt) => handleChange(evt, "degradation")}
						></input>
					</Col>
				</Col>
			</Row>
		</>
	);
};

export default TargetDegradeSection;
